import React, { ElementType, MouseEventHandler, ReactNode } from 'react'
import { ListItem as MUIListItem, SxProps } from '@mui/material'

interface ListItemProps {
  alignItems?: 'center' | 'flex-start'
  children: ReactNode
  component?: ElementType<any>
  dense?: boolean
  disableGutters?: boolean
  disablePadding?: boolean
  divider?: boolean
  id?: string
  onMouseMove?: (() => void) | MouseEventHandler<HTMLElement>
  secondaryAction?: ReactNode
  sx?: SxProps
}

/**
 * [INSERT DESCRIPTION]
 */

const ListItem = React.forwardRef((props: ListItemProps, ref: any) => {
  const { children, ...rest } = props

  return (
    <MUIListItem {...rest} ref={ref}>
      {children}
    </MUIListItem>
  )
})

ListItem.displayName = 'ListItem'
export default ListItem
